export default __webpack_public_path__ + "static/media/HFS00513_WEDDING_1084.7cdd6623.jpg";